import ErisSearchComponent from './components/ErisSearchComponent';
import { useErisInformationStore } from 'src/api/eris/store/ErisInformationStore';
import ErisStatusResultsComponent from './components/statusResults/ErisStatusResultsComponent';
import ErisStatusSummaryComponent from './components/summaryResults/ErisStatusSummaryComponent';
import ErisHeader from '../common/header/ErisHeader';
import ErisFooter from '../common/footer/ErisFooter';
import { useState } from 'react';
import { LoadingSpinner } from '../common/loading/LoadingSpinner';

const ErisMain = () => {
  const { statusResult, statusSummaryList, isSearchingResults } = useErisInformationStore();
  const [showStatus, setShowStatus] = useState(false);
  const [showSummary, setShowSummary] = useState(false);

  return (
    <div className="min-w-max px-2">
      <div className="sticky top-0 z-50">
        <ErisHeader />
      </div>
      <main className="py-4">
        <ErisSearchComponent
          showStatus={showStatus}
          setShowStatus={setShowStatus}
          showSummary={showSummary}
          setShowSummary={setShowSummary}
        />
        {isSearchingResults && <LoadingSpinner />}
        {statusResult !== null && !isSearchingResults && showStatus && (
          <ErisStatusResultsComponent />
        )}
        {(statusSummaryList?.groupSummaries ?? []).length !== 0 &&
          !isSearchingResults &&
          showSummary && <ErisStatusSummaryComponent />}
      </main>
      <div className="sticky bottom-0 z-50">
        <ErisFooter />
      </div>
    </div>
  );
};

export default ErisMain;
